import script from "./Payments-Deductions-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"
export * from "./Payments-Deductions-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"

import "./Payments-Deductions-Questionnaire-Main.vue?vue&type=style&index=0&id=674247ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-674247ec"]])

export default __exports__